/*
 * @Author: vince
 * @Date: 2022-11-27 16:21:13
 * @LastEditors: vince 273187189@qq.com
 * @LastEditTime: 2022-11-28 18:22:14
 * @Description:
 */
import axios from 'axios'
import { Message } from 'element-ui';
// 月份  9, 10 , 11 , 12 ,1 第一学期
// 月份  2, 3 ,4 ,5 , 6 ,7 ,8 第二学期
// 学年 当前月小于9  当前年份-1
//获取苏宁服务器时间
function getTime(callback) {
	axios.get("/user/getCurrentSchoolYearTerm").then(res => {
		//"2021-06-09"
		callback(res.data)
	}).catch(err => {

	})
}
export { getTime }
